import { render, staticRenderFns } from "./MerchantListAddNew.vue?vue&type=template&id=4f622353&"
import script from "./MerchantListAddNew.vue?vue&type=script&lang=js&"
export * from "./MerchantListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MerchantListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports